<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4">施工许可</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称：</td>
                        <td>{{ baseInfo.projectName }}</td>
                        <td class="font-bold">项目编号：</td>
                        <td>{{ baseInfo.projectCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">施工许可证编号：</td>
                        <td>{{ baseInfo.constructionPermitCode || '-' }}</td>
                        <td class="font-bold">项目位置：</td>
                        <td>{{ baseInfo.address || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">建设单位：</td>
                        <td><span :class="baseInfo.hasContact ? 'active-color' : ''"
                                @click="baseInfo.hasContact && handlerLinkLocal('/contact/detail?id=' + baseInfo.companyName + '&type=2')">{{
                                baseInfo.companyName || '-' }}</span></td>
                        <td class="font-bold">建设单位项目负责人：</td>
                        <td>{{ baseInfo.constructManager }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">合同工期开始日期：</td>
                        <td>{{ baseInfo.beginDate }}</td>
                        <td class="font-bold">合同工期结束日期：</td>
                        <td>{{ baseInfo.endDate || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">建设规模：</td>
                        <td>{{ baseInfo.constructScale || '-' }}</td>
                        <td class="font-bold">合同价格：</td>
                        <td>{{ baseInfo.contractMoney ? baseInfo.contractMoney + baseInfo.contractMoneyUnit : '-' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-bold">工程总承包单位：</td>
                        <td>{{ baseInfo.undertakeOrgName || '-' }}</td>
                        <td class="font-bold">工程总承包项目经理：</td>
                        <td>{{ baseInfo.undertakeManager || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">勘察单位：</td>
                        <td>{{ baseInfo.prospectingOrgName || '-' }}</td>
                        <td class="font-bold">勘察单位项目负责人：</td>
                        <td>{{ baseInfo.prospectingManager || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">设计单位：</td>
                        <td>{{ baseInfo.prospectingOrgName || '-' }}</td>
                        <td class="font-bold">设计单位项目负责人：</td>
                        <td>{{ baseInfo.designManager || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">施工单位：</td>
                        <td>{{ baseInfo.buildOrgName || '-' }}</td>
                        <td class="font-bold">施工单位项目负责人：</td>
                        <td>{{ baseInfo.buildManager || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">监理单位：</td>
                        <td>{{ baseInfo.supervisorOrgName || '-' }}</td>
                        <td class="font-bold">总监理工程师：</td>
                        <td>{{ baseInfo.supervisor || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">区域：</td>
                        <td>{{ baseInfo.province + '-' + baseInfo.city + '-' + baseInfo.county }}</td>
                        <td class="font-bold">备注：</td>
                        <td>{{ baseInfo.remark || '-' }}</td>
                    </tr>
                </table>
                <ad :type="2"></ad>
                <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'关联项目'" :pageType="1" :relatedByData="extend.relatedByCompanyName">
                </relatedBy>

                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.companyName + '）关联项目'" :pageType="2"
                    :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import relatedBy from '../components/relatedBy.vue';
export default {
    components: {
        relatedBy
    },
    data() {
        return {
            id: this.$route.query.id || null,
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
            extend:{}
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let ajaxUrl = this.$api.common.buildPermit.Detail() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('公告数据详情', res);
                if(res.success) {
                    this.baseInfo = res.data || {};
                    this.extend = res.extend || {};
                }else {
                    this.$message.error(res.msg || '获取数据失败');
                }
                this.pageLoading = false;
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>